import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControlLabel,
  Grid,
  Skeleton,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useEffect } from "react";
import {
  convertBase64,
  getUserData,
} from "../../../../Base/helper/baseFunctions";
import { GetOfferLetterTemplateHelper } from "../../../helper/AtsFormTemplateHelper";
import {
  GetOfferLetterTemplateResponseHelper,
} from "../../../helper/AtsFormTemplateResponseHelper";
import { OfferComponentsRender } from "../OfferComponentsRender";
const PromptInput = ({
  currentData,
  currentJobData,
  activeStep,
  setActiveStep,
  resData,
  setResData,
  setIsOfferForm,
  OfferEdit,
  payConfigResponse,
  setPayConfigResponse,
  isConfigureCtc,
  setIsConfigureCtc,
}) => {
  const [viewMode, setViewMode] = useState("Loading");
  const [formFields, setFormFields] = useState([]);
  const [formComponents, setFormComponents] = useState([]);
  const [formHeading, setFormHeading] = useState({ heading: "" });
  const [description, setDescription] = useState("");
  const [formData, setFormData] = useState({});
  const [previewErrors, setpreviewErrors] = useState({});
  const [checkData, setCheckData] = useState({ values: [] });
  const [templateIsConfigureCtc, setTemplateIsConfigureCtc] = useState(true);
  const userData = getUserData();
  const cleanFieldKey = (val) => (val || "").toString().toLowerCase().replace(/[^a-z0-9]/g, "");
  const isCtcField = (f) => cleanFieldKey(f?.name) === "ctc";
  const isCtcInWordsField = (f) => {
    const n = cleanFieldKey(f?.name);
    return n === "ctcinwords" || n === "ctcinword";
  };
  const isCandidateNameField = (f) => cleanFieldKey(f?.name) === "candidatename";
  const isOfferLetterNoField = (f) => cleanFieldKey(f?.name) === "offerletterno";
  const prepareFieldsWithDefaults = (fields) => {
    if (!Array.isArray(fields)) return [];
    return fields
      .filter((f) => !isCtcField(f) && !isCtcInWordsField(f) && !isOfferLetterNoField(f))
      .map((f) => (isCandidateNameField(f) ? { ...f, disable: false } : f));
  };


  useEffect(() => {
    const extractSavedFields = (source) => {
      const result = {};
      if (source) {
        const parsed = typeof source === "string" ? JSON.parse(source) : source;
        Object.keys(parsed).forEach((key) => {
          result[key.replace("@{", "").replace("}", "")] = parsed[key];
        });
      }
      return result;
    };

    if (currentData?.offer_letter_response_id && OfferEdit === "true") {
      GetOfferLetterTemplateResponseHelper({
        offer_letter_response_id: currentData?.offer_letter_response_id,
      }).then((res) => {
        setFormFields(prepareFieldsWithDefaults(res?.data?.data[0]?.offer_letter_template_fields));
        setViewMode("Feedback");
        setDescription(
          res?.data?.data[0]?.offer_letter_edited ||
            res?.data?.data[0]?.offer_letter_response ||
            ""
        );
        const savedFields = resData?.form_data || resData?.offer_letter_fields_response || res?.data?.data?.[0]?.offer_letter_fields_response;
        const initialFormData = extractSavedFields(savedFields);
        if (!initialFormData.candidate_name) {
          initialFormData.candidate_name = currentData?.full_name ?? "";
        }
        setFormData(initialFormData);
        const checkVals = [];
        Object.values(initialFormData).forEach((val) => {
          if (Array.isArray(val)) checkVals.push(...val);
        });
        if (checkVals.length > 0) {
          setCheckData({ values: checkVals });
        }
        setPayConfigResponse((prev) => ({
          ...prev,
          payconfig_input_json: res?.data?.data?.[0]?.payconfig_input_json || "",
          payconfig_content: res?.data?.data?.[0]?.payconfig_content || ""
        }))
        const templateCtc = res?.data?.data?.[0]?.is_configure_ctc;
        if (templateCtc === false) {
          setTemplateIsConfigureCtc(false);
          if (setIsConfigureCtc) {
            setIsConfigureCtc(false);
          }
        } else {
          setTemplateIsConfigureCtc(true);
          if (res?.data?.data?.[0]?.is_configure_ctc !== undefined && setIsConfigureCtc && resData?.is_configure_ctc === undefined) {
            setIsConfigureCtc(Boolean(res.data.data[0].is_configure_ctc));
          }
        }
      });
    } else {
      GetOfferLetterTemplateHelper({
        workspace: userData?.domain,
        offer_letter_template_id: currentJobData?.offer_letter_template_id,
      }).then((res) => {
        setFormFields(prepareFieldsWithDefaults(res?.data?.data[0]?.offer_letter_template_fields));
        setFormHeading({
          heading: res?.data?.data[0]?.offer_letter_template_name,
        });
        const templateCtc = res?.data?.data?.[0]?.is_configure_ctc;
        if (templateCtc === false) {
          setTemplateIsConfigureCtc(false);
          if (setIsConfigureCtc) {
            setIsConfigureCtc(false);
          }
        } else {
          setTemplateIsConfigureCtc(true);
          if (setIsConfigureCtc && resData?.is_configure_ctc === undefined) {
            setIsConfigureCtc(true);
          }
        }
        const savedFields = resData?.form_data || resData?.offer_letter_fields_response || currentData?.offer_letter_fields_response;
        const initialFormData = extractSavedFields(savedFields);
        if (!initialFormData.candidate_name && currentData?.full_name) {
          initialFormData.candidate_name = currentData.full_name;
        }
        setFormData(initialFormData);
        const checkVals = [];
        Object.values(initialFormData).forEach((val) => {
          if (Array.isArray(val)) checkVals.push(...val);
        });
        if (checkVals.length > 0) {
          setCheckData({ values: checkVals });
        }
        setViewMode("Feedback");
      });
    }

    //eslint-disable-next-line
  }, []);


  const Previewvalidate = (fieldDefinitions, fieldValues) => {
    let temp = { ...previewErrors };
    fieldDefinitions?.forEach((field, index) => {
      if (isCtcField(field) || isCtcInWordsField(field)) {
        temp[field.name] = "";
        return;
      }
      const isRequired = field.required;
      if (isRequired && !fieldValues[field.name]) {
        temp[field.name] = `${field.label} is required`;
      } else {
        temp[field.name] = "";
      }
    });
    setpreviewErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };

  const handleResponseSubmit = async () => {
    if (Previewvalidate(formFields, formData)) {
      let b64string = "";
      let filename = "";
      for (const field of formFields) {
        const fieldName = field.name;
        const fieldType = field.type;
        if (fieldType === "file" && formData[fieldName]) {
          const fileField = formData[fieldName];
          if (fileField instanceof File) {
            b64string = await convertBase64(fileField);
            const ext = fileField.name.split(".").pop();
            filename = `${
              userData?.domain
            }/ATS/OfferLetter/Documents/${uuidv4()}.${ext}`;
            formData[fieldName] = filename;
            break;
          }
        }
      }
      const transformedData = {};
      for (let key in formData) {
        transformedData[`@{${key}}`] = formData[key];
      }
      setResData((prev) => ({
        ...prev,
        ...currentData,
        offer_letter_fields_response: transformedData,
        form_data: { ...formData },
        file: b64string,
        file_name: filename,
        is_configure_ctc: isConfigureCtc,
      }));
      setActiveStep(activeStep + 1);
    }
  };

  return (
    <>
      {viewMode === "Loading" ? (
        <Box sx={{ width: "60%", mx: "auto", marginTop: 2 }}>
          <Box>
            <Skeleton variant="rectangular" width="100%" height={200} />
            <Skeleton variant="rectangular" width="100%" height={200} />
          </Box>
        </Box>
      ) : (
        viewMode === "Feedback" && (
          <>
            <Box className="response-main">
              {formFields?.length > 0 && (
                <>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                      <Box sx={{ textAlign: "center" }}>
                        <Typography
                          variant="h4"
                          gutterBottom
                          fontSize="2.25rem"
                        >
                          {formHeading?.heading}
                        </Typography>
                      </Box>
                      <Grid container className="form_content">
                        <OfferComponentsRender
                          formFields={formFields}
                          checkData={checkData}
                          setCheckData={setCheckData}
                          formData={formData}
                          setFormData={setFormData}
                          previewErrors={previewErrors}
                          Previewvalidate={Previewvalidate}
                        />
                      </Grid>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mt: 2,
                        }}
                      >       
                        <FormControlLabel
                          control={
                            <Switch
                              checked={Boolean(isConfigureCtc)}
                              disabled={templateIsConfigureCtc === false}
                              onChange={(e) => setIsConfigureCtc && setIsConfigureCtc(e.target.checked)}
                              color="primary"
                            />
                          }
                          label={
                            <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                              <span>Configure CTC</span>
                              <Tooltip
                                title={
                                  templateIsConfigureCtc === false
                                    ? "CTC configuration is disabled for this template."
                                    : "Enable to configure salary and CTC components for this candidate in the next step. If disabled, CTC configuration will be skipped."
                                }
                                arrow
                                placement="top"
                              >
                                <InfoOutlinedIcon sx={{ fontSize: 16, color: "#64748b", cursor: "pointer" }} />
                              </Tooltip>
                            </Box>
                          }
                          sx={{ mr: 0 }}
                        />
                        <Box sx={{ display: "flex", gap: 2 }}>
                          {OfferEdit === "true" && (
                            <Button
                              variant="contained"
                              className="mpl-primary-btn"
                              onClick={() => setIsOfferForm(false)}
                            >
                              Cancel
                            </Button>
                          )}
                          <Button
                            variant="contained"
                            className="mpl-primary-btn"
                            onClick={handleResponseSubmit}
                          >
                            Next
                          </Button>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </>
              )}
            </Box>
          </>
        )
      )}
    </>
  );
};
export default PromptInput;
